import _ from 'lodash';

window.tinymce.PluginManager.add('lineheight', function init(editor) {
    var getSpecifiedProp = function (propName, rootElement, element) {
        while (element !== rootElement) {
            if (element.tagName === 'P') {
                const value = element.style[propName] ||
                    window.getComputedStyle(element, null).getPropertyValue(propName);
                if (value) {
                    if (/[0-9.]+px$/.test(value)) {
                        return Math.round(parseInt(value, 10) * 72 / 96) + 'pt';
                    }
                    return value;
                }
            }
            element = element.parentNode;
        }
        return '';
    };

    editor.on('init', function() {
        editor.formatter.register('lh', {
            block: 'p',
            styles: {lineHeight: '%value'},
        });
        editor.formatter.register('mt', {
            block: 'p',
            styles: {marginTop: '%value'},
        });
        editor.formatter.register('border_bottom', [
            {
                inline: 'span',
                styles: {borderBottom: '1px solid black'},
                split: true,
                'remove_similiar': true,
                links: true,
            },
            {
                inline: 'span',
                selector: 'span',
                styles: {borderBottom: '1px solid black'},
                split: true,
                inherit: false,
                defaultBlock: 'span',
                'remove_similiar': true,
                remove: 'border_bottom',
                ceFalseOverride: true,
            },
        ]);
        editor.formatter.register('border', [
            {
                inline: 'span',
                styles: {border: '1px solid black'},
                split: true,
                'remove_similiar': true,
                links: true,
            },
            {
                inline: 'span',
                selector: 'span',
                styles: {border: '1px solid black'},
                split: true,
                inherit: false,
                defaultBlock: 'span',
                'remove_similiar': true,
                remove: 'border',
                ceFalseOverride: true,
            },
        ]);

        editor.formatter.register('float_left', [
            {
                inline: 'span',
                styles: {float: 'left'},
                split: true,
                'remove_similiar': true,
                links: true,
            },
            {
                inline: 'span',
                selector: 'span',
                styles: {float: 'left'},
                split: true,
                inherit: false,
                defaultBlock: 'span',
                'remove_similiar': true,
                remove: 'float_left',
                ceFalseOverride: true,
            },
        ]);
        editor.formatter.register('float_right', [
            {
                inline: 'span',
                styles: {float: 'right'},
                split: true,
                'remove_similiar': true,
                links: true,
            },
            {
                inline: 'span',
                selector: 'span',
                styles: {float: 'right'},
                split: true,
                inherit: false,
                defaultBlock: 'span',
                'remove_similiar': true,
                remove: 'float_right',
                ceFalseOverride: true,
            },
        ]);
        editor.formatter.register('score', [
            {
                inline: 'span',
                attributes: {
                    'data-score': '%value',
                    'data-score-id': function() {
                        const elements = editor.contentWindow.document.querySelectorAll('[data-score-id]');
                        const indices = [];
                        _.forEach(elements, element => indices.push(Number(element.dataset['scoreId'])));
                        let id = 1;
                        while (_.includes(indices, id))
                            id += 1;
                        return id;
                    },
                },
                deep: true,
                classes: 'score',
                split: true,
                'remove_similiar': true,
                links: true,
            },
            {
                inline: 'span',
                selector: 'span',
                attributes: {
                    'data-score': '%value',
                    'data-score-id': function() {
                        const elements = editor.contentWindow.document.querySelectorAll('[data-score-id]');
                        const indices = [];
                        _.forEach(elements, element => indices.push(Number(element.dataset['scoreId'])));
                        let id = 1;
                        while (_.includes(indices, id))
                            id += 1;
                        return id;
                    },
                },
                deep: true,
                classes: 'score',
                split: true,
                inherit: false,
                defaultBlock: 'span',
                'remove_similiar': true,
                remove: 'score',
                ceFalseOverride: true,
            },
        ]);
        editor.formatter.register('valign_top', {
            selector: 'img,*[style*=\'display: inline-block\']',
            ceFalseOverride: true,
            styles: {verticalAlign: 'top'},
        });
        editor.formatter.register('valign_middle', {
            selector: 'img,*[style*=\'display: inline-block\']',
            ceFalseOverride: true,
            styles: {verticalAlign: 'middle'},
        });
        editor.formatter.register('valign_bottom', {
            selector: 'img,*[style*=\'display: inline-block\']',
            ceFalseOverride: true,
            styles: {verticalAlign: 'bottom'},
        });
    });

    const lhvalues = [{
        text: 'normal',
        value: 'normal',
    }];
    for (let h = 8; h <= 30; h++) {
        lhvalues.push({
            text: h.toFixed(1) + 'pt',
            value: h + 'pt',
        });
    }

    const mtvalues = [];
    for (let h = -10; h <= 40; h++) {
        mtvalues.push({
            text: h + 'pt',
            value: h + 'pt',
        });
    }

    const scoreValues = [{
        icon: 'custom fa-times',
        onclick() {
            editor.focus();
            editor.formatter.remove('score');
            editor.nodeChanged();
        },
    }];
    for (let value = .25; value <= 20; value += .25) {
        scoreValues.push({
            text: value.persian(),
            value: value,
            onclick() {
                setStyle('score', this.value());
            },
        });
    }

    //the function that toggles the inline style
    function setStyle(format, v) {
        editor.focus();
        editor.formatter.toggle(format, {value: v});
        editor.nodeChanged();
    }

    editor.addCommand('BorderBottom', () => {
        editor.focus();
        editor.formatter.toggle('border_bottom', {});
        editor.nodeChanged();
    });

    editor.addCommand('Border', () => {
        editor.focus();
        editor.formatter.toggle('border', {});
        editor.nodeChanged();
    });

    editor.addCommand('FloatLeft', () => {
        editor.focus();
        editor.formatter.toggle('float_left', {});
        editor.nodeChanged();
    });

    editor.addCommand('FloatRight', () => {
        editor.focus();
        editor.formatter.toggle('float_right', {});
        editor.nodeChanged();
    });

    editor.addCommand('HalfSpace', () => {
        editor.execCommand(
            'mceInsertContent',
            false,
            '‌',
        );
    });

    editor.addCommand('AlignTop', () => {
        editor.focus();
        _.forEach(
            ['bottom', 'middle'],
            (name) => editor.formatter.remove('valign_' + name),
        );
        editor.formatter.toggle('valign_top');
        editor.nodeChanged();
    });

    editor.addCommand('AlignMiddle', () => {
        editor.focus();
        _.forEach(
            ['bottom', 'top'],
            (name) => editor.formatter.remove('valign_' + name),
        );
        editor.formatter.toggle('valign_middle');
        editor.nodeChanged();
    });

    editor.addCommand('AlignBottom', () => {
        editor.focus();
        _.forEach(
            ['middle', 'top'],
            (name) => editor.formatter.remove('valign_' + name),
        );
        editor.formatter.toggle('valign_bottom');
        editor.nodeChanged();
    });

    editor.addShortcut('ctrl+32', '', () => editor.execCommand('HalfSpace'));

    editor.addButton('lineheight', {
        type: 'listbox',
        text: window.gettext('Line Height'),
        tooltip: window.gettext('Line Height'),
        values: lhvalues,
        fixedWidth: true,
        onPostRender: function () {
            editor.on('nodeChange', event => {
                let value = getSpecifiedProp('line-height', editor.getBody(), event.element);
                let selectedValue;

                _.forEach(lhvalues, item => {
                    if (item.value === value) {
                        selectedValue = value;
                    }
                });

                this.value(selectedValue);

                if (!selectedValue) {
                    this.text(value || 'normal');
                }
            });
        },
        onclick: function (e) {
            if (e.control.settings.value) {
                setStyle('lh', e.control.settings.value);
            }
        },
    });

    editor.addButton('paragraph_spacing', {
        type: 'listbox',
        text: window.gettext('Top Margin'),
        tooltip: window.gettext('Top Margin'),
        values: mtvalues,
        fixedWidth: true,
        onPostRender: function () {
            editor.on('nodeChange', event => {
                let value = getSpecifiedProp('margin-top', editor.getBody(), event.element);
                let selectedValue;

                _.forEach(mtvalues, item => {
                    if (item.value === value) {
                        selectedValue = value;
                    }
                });

                this.value(selectedValue);

                if (!selectedValue) {
                    this.text(value || '9pt');
                }
            });
        },
        onclick: function (e) {
            if (e.control.settings.value) {
                setStyle('mt', e.control.settings.value);
            }
        },
    });

    editor.addButton('border_bottom', {
        tooltip: 'Border Bottom',
        icon: 'custom fa-underline',
        cmd: 'BorderBottom',
        stateSelector: '*[style*=\'border-bottom: 1px solid\']',
    });

    editor.addButton('border', {
        tooltip: 'Border',
        icon: 'custom fa-square-o',
        cmd: 'Border',
        stateSelector: '*[style*=\'border: 1px solid\']',
    });

    editor.addButton('float_left', {
        tooltip: 'Float Left',
        icon: 'custom fa-hand-o-left',
        cmd: 'FloatLeft',
        stateSelector: '*[style*=\'float: left\']',
    });

    editor.addButton('float_right', {
        tooltip: 'Float Right',
        icon: 'custom fa-hand-o-right',
        cmd: 'FloatRight',
        stateSelector: '*[style*=\'float: right\']',
    });

    editor.addButton('score', {
        type: 'menubutton',
        tooltip: 'Point',
        icon: 'custom fa-pencil-square-o',
        menu: scoreValues,
    });

    editor.addButton('align_top', {
        tooltip: 'Align Top',
        icon: 'custom fa-long-arrow-up',
        cmd: 'AlignTop',
        stateSelector: '*[style*=\'vertical-align: top\']',
    });

    editor.addButton('align_middle', {
        tooltip: 'Align Middle',
        icon: 'custom fa-arrows-v',
        cmd: 'AlignMiddle',
        stateSelector: '*[style*=\'vertical-align: middle\']',
    });

    editor.addButton('align_bottom', {
        tooltip: 'Align Bottom',
        icon: 'custom fa-long-arrow-down',
        cmd: 'AlignBottom',
        stateSelector: '*[style*=\'vertical-align: bottom\']',
    });
});
